<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button
        (click)="createTimeEntry()"
        [disabled]="userError || timeError || singleCollisionError"
        *ngIf="!absenceEntryId"
        >Abwesenheitsantrag anlegen</ion-button
      >
      <ion-button
        (click)="updateTimeEntry()"
        [disabled]="
          userError ||
          timeError ||
          singleCollisionError ||
          (absenceEntryId && showWeekendInfo)
        "
        *ngIf="absenceEntryId"
        >Abwesenheitsantrag aktualisieren</ion-button
      >
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div class="select-form" *ngIf="state.userHasMinType(1)">
      <lib-user-picker
        [users]="this.state.users$"
        [showAllEntry]="false"
        [multiple]="absenceEntryId == null"
        (selectedUserChanged)="userChange($event)"
        [preselectedUsers]="selectedUsers"
      ></lib-user-picker>
    </div>

    @if(!absenceEntryId){
    <div class="select-form wide">
      <div>Start</div>
      <div>Ende</div>
    </div>
    <div class="select-form wide">
      <!--lib-date-range-picker></lib-date-range-picker-->
      <lib-date-time-picker
        [type]="'date'"
        (selectedDateChanged)="startDateChanged($event)"
      ></lib-date-time-picker>
      <div>
        <lib-date-time-picker
          [type]="'date'"
          (selectedDateChanged)="endDateChanged($event)"
        ></lib-date-time-picker>
      </div>
    </div>
    @if(timeError){
    <div class="select-form collision-warning">
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>
        Fehler: Endzeit liegt vor Startzeit
      </div>
    </div>
    } }@else{
    <div class="select-form wide">
      <lib-date-time-picker
        [type]="'date'"
        [inputDateZulu]="absenceEntry.date"
        (selectedDateChanged)="dateChanged($event)"
      ></lib-date-time-picker>
    </div>
    } @if(!timeError && !absenceEntryId){
    <div class="select-form">
      {{ dayCount }}
      @if(dayCount > 1){ Tage }@else{ Tag } abwesend
    </div>
    } @if(showWeekendInfo){
    <div class="select-form no-workday-warning">
      <div class="centered">
        <ion-icon
          size="small"
          name="information-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>
        Info: Wochenende ausgewählt - Wochenendtage werden nicht angelegt
      </div>
    </div>
    } @if(singleCollisionError){
    <div class="select-form collision-warning">
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>
        Fehler: Für dieses Datum existiert bereits ein Abwesenheitsantrag
      </div>
    </div>
    }@if(collisionErrorList.length > 0){
    <div class="select-form collision-warning">
      <div>Folgende Abwesenheiten werden nicht angelegt:</div>
      @for(error of collisionErrorList; track error){
      <div class="centered">
        <ion-icon
          size="small"
          name="alert-circle-outline"
          style="margin-right: 4px"
        ></ion-icon>

        {{ error }}
      </div>
      }
    </div>
    }

    <div class="select-form">
      @if(!absenceEntryId){
      <ion-select
        label="Typ"
        label-placement="floating"
        mode="md"
        fill="outline"
        [(ngModel)]="this.absenceEntryRequest.type"
        interface="popover"
      >
        <ion-select-option
          *ngFor="let type of this.typeOptions"
          [value]="type"
          >{{ type }}</ion-select-option
        >
      </ion-select>
      }@else{
      <ion-select
        label="Typ"
        label-placement="floating"
        mode="md"
        fill="outline"
        [(ngModel)]="this.absenceEntry.type"
        interface="popover"
      >
        <ion-select-option
          *ngFor="let type of this.typeOptions"
          [value]="type"
          >{{ type }}</ion-select-option
        >
      </ion-select>
      }
    </div>
    <div class="select-form">
      <ion-textarea
        label="Beschreibung"
        labelPlacement="floating"
        fill="outline"
        [autoGrow]="true"
        mode="md"
        [(ngModel)]="absenceEntry.description"
        placeholder="Beschreibung hinzufügen.."
      ></ion-textarea>
    </div>
  </div>
</ion-content>
